/** Ausencia de fuente no inventa un costo; backend solicita revisión específica. */
export const materialTransitionPayload = (value) =>
  value?.unit_cost_ars !== '' && value?.unit_cost_ars != null
    ? {
        unit_cost_ars: Number(value.unit_cost_ars),
        notes: value.notes,
        evidence: { references: value.evidence },
      }
    : undefined;
